import React from 'react'

const LABELS = {
  nome: 'Nome',
  sobrenome: 'Sobrenome',
  email: 'E-mail',
  password: 'Senha',
  password_confirmation: 'Confirmação de senha',
  current_password: 'Senha atual',
  data_levantamento: 'Data de levantamento',
  video_url: 'URL do vídeo',
  observacoes: 'Observações',
  polo_id: 'Polo',
  lote_id: 'Lote',
}

function humanize(field) {
  return LABELS[field] || field.replace(/_/g, ' ').replace(/^./, c => c.toUpperCase())
}

export default function ErrorSummary({ errors }) {
  if (!errors) return null
  const entries = Object.entries(errors).filter(([, msgs]) => msgs && (Array.isArray(msgs) ? msgs.length : true))
  if (entries.length === 0) return null

  return (
    <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-md text-sm">
      <p className="font-medium text-red-800 mb-1">Corrija os seguintes erros:</p>
      <ul className="list-disc pl-5 text-red-700 space-y-0.5">
        {entries.map(([field, msgs]) => {
          const list = Array.isArray(msgs) ? msgs : [msgs]
          return list.map((msg, i) => (
            <li key={`${field}-${i}`}>{humanize(field)}: {msg}</li>
          ))
        })}
      </ul>
    </div>
  )
}
